import {Parameter, SignatureFileData} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalSignatureFileData extends SignatureFileData implements Parameter {
	public name?: string;
	public mimetype?: string;

	constructor(data: any) {
		super(data);

		this.name = FunctionHelper.exists(data?.name) ? data.name : "";
		this.mimetype = FunctionHelper.exists(data?.mimetype) ? data.mimetype : "";
	}

	public static getNameDefault(): string {
		return "";
	}

	public static getMimetypeDefault(): string {
		return "";
	}

	public static fromJson(data: any): PortalSignatureFileData {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalSignatureFileData(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'name': this.name,
			'mimetype': this.mimetype
		};
	}

	public clone(): PortalSignatureFileData {
		return PortalSignatureFileData.fromJson(this.toJson());
	}
}